import * as Yup from "yup";

import { CommissionTypes } from "constants/commissions";
import { validatePercentage } from "./validators";

enum CommissionValidationMessage {
  REQUIRED = "Required",
}

export const commissionFieldsShape = {
  commissionType: Yup.string()
    .oneOf(Object.values(CommissionTypes))
    .required(CommissionValidationMessage.REQUIRED),
  commissionValue: Yup.number()
    .nullable()
    .when("commissionType", {
      is: CommissionTypes.Percentage,
      then: validatePercentage(12, 6),
    })
    .required(CommissionValidationMessage.REQUIRED),
};

export const commissionSchema = Yup.object()
  .default(undefined) // allow it to be left out of payload = no change to commission
  .nullable() // null = remove commission
  .shape(commissionFieldsShape);
